import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { setPendingReferralCode } from '@/lib/referral-store'
import styles from './referral-claim.module.css'

export const Route = createFileRoute('/r/$refCode')({
  component: ReferralClaimRoute,
})

function ReferralClaimRoute() {
  const { refCode } = Route.useParams()

  useEffect(() => {
    const normalized = refCode.trim().toUpperCase()
    if (normalized.length === 0) {
      window.location.replace('/signup')
      return
    }

    setPendingReferralCode(normalized)
    window.location.replace(`/signup?ref=${encodeURIComponent(normalized)}`)
  }, [refCode])

  return (
    <section className={styles.panel}>
      <h1 className={styles.title}>Applying friend invite...</h1>
      <p className={styles.subtitle}>
        If this page does not redirect automatically, continue to signup with your invite locked in.
      </p>
      <a
        className={styles.link}
        href={`/signup?ref=${encodeURIComponent(refCode.trim().toUpperCase())}`}
      >
        Continue to signup
      </a>
    </section>
  )
}
